import apiClient from './axios-config';

export const landingApi = {
  getAcademyCourses: () => apiClient.get('/landing-page/academy/courses'),
  getAcademyCourse: (idOrSlug) => apiClient.get(`/landing-page/academy/courses/${idOrSlug}`),
  getEvents: () => apiClient.get('/landing-page/events'),
};
